import { useEffect } from 'react';

/**
 * Hook to warn the user before closing or refreshing the tab.
 * Works in React Router DOM v6.30+ with BrowserRouter.
 */
export default function useExitPrompt(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ''; // Required for Chrome to show prompt
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [enabled]);
}
